import { useState } from "react";
import { RemoveAssistanceScreen } from "../../screen/RemoveAssistanceScreen";
import { customToast } from "../../components/Toast";
import Send from "../../core/communication";
import { useScope } from "../SelectProjectCompanyContainer";

export const RemoveAssistanceContainer = ({ selectedRows, handleCloseActionModal, isEvent }) => {
  const { scope } = useScope();
  const [selectedOptions, setSelectedOptions] = useState([
    'assistance', 
    'event'
  ]);
  const [modalIsOpen, setModalIsOpen] = useState(false)

  const changeOptions = (selectedRows) => {
    setSelectedOptions(selectedRows)
  }

  const handleOpenModal = () =>  setModalIsOpen(true);

  const handleCloseModal = () => {
    setModalIsOpen(false);
    handleCloseActionModal();
  }

  const handleRemove = async () => {
    try {
      const response = await Send.post('/events-sector/delete-bySteps', {
        steps: selectedOptions,
        projectId: scope?.id,
        selectedRows,
        isEvent
      });

      if(!response.status || response.status === 'error') {
        throw new Error(response);
      }

      const messageToast = isEvent ? `Remoção de ${selectedRows?.length} atendimento(s) agendado(s) concluída com sucesso!` 
      : `Remoção de ${selectedRows?.length} atendimento(s) concluída com sucesso!`

      customToast(messageToast, 'success');
      setModalIsOpen(false)
      handleCloseActionModal();
    } catch(error) {
      customToast('Falha ao remover evento', 'error');
      console.log('Falha ao remover evento', error);
    }
  }

  return <RemoveAssistanceScreen {...{
      changeOptions,
      selectedOptions,
      modalIsOpen,
      handleOpenModal,
      handleCloseModal,
      handleRemove
    }}
  />
}